console.log("✅ Header rendered once");

import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import { Link } from "react-router-dom";

const Header = ({ onLoginClick, onRegisterClick }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef();
  const buttonRef = useRef();

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (buttonRef.current && buttonRef.current.contains(e.target)) return;
      if (menuOpen && navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  return (
    <header className="quirkle-header">
      {/* LOGO */}
      <div className="quirkle-logo">
        <Link to="/">Quirkle</Link>
      </div>

      {/* DESKTOP NAVIGATION */}
      <nav className="quirkle-center-nav">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/about" className="nav-link">About Us</Link>
        <Link to="/services" className="nav-link">Services</Link>
        <Link to="/contact" className="nav-link">Contact</Link>
      </nav>

      {/* AUTH BUTTONS */}
      <div className="quirkle-auth-buttons">
        <button onClick={onLoginClick} className="nav-button">Login</button>
        <button onClick={onRegisterClick} className="nav-button nav-button-primary">
          Register
        </button>
      </div>

      {/* MOBILE MENU BUTTON */}
      <button
        ref={buttonRef}
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? "✖" : "☰"}
      </button>

      {/* MOBILE DROPDOWN */}
      <nav
        ref={navRef}
        className={`quirkle-nav mobile-nav ${menuOpen ? "open" : ""}`}
      >
        <Link
          to="/"
          className="mobile-link"
          onClick={() => setMenuOpen(false)}
        >
          Home
        </Link>

        <Link
          to="/about"
          className="mobile-link"
          onClick={() => setMenuOpen(false)}
        >
          About Us
        </Link>

        <Link
          to="/services"
          className="mobile-link"
          onClick={() => setMenuOpen(false)}
        >
          Services
        </Link>

        <Link
          to="/contact"
          className="mobile-link"
          onClick={() => setMenuOpen(false)}
        >
          Contact
        </Link>

        <hr />

        <button
          onClick={() => {
            onLoginClick();
            setMenuOpen(false);
          }}
          className="nav-button"
        >
          Login
        </button>

        <button
          onClick={() => {
            onRegisterClick();
            setMenuOpen(false);
          }}
          className="nav-button nav-button-primary"
        >
          Register
        </button>
      </nav>
    </header>
  );
};

export default Header;
